import React from 'react'
import "./CustomButton.css"
import { Spinner } from 'react-bootstrap'
function CustomButton({ text, onPress, disable, type }) {
  return (
    <>
      <button
      type={type}
        onClick={onPress}
         disable={false}
        className={`btnContainer ${disable ? "disableContainer" : ""}`}
      >
        {disable &&
          <Spinner animation="border" variant="white" size='sm' className='sinner' />

        }
        {text}

      </button>

    </>
  )
}

export default CustomButton
